import * as R from 'ramda';

const setIsReturningFromOverride = store => async state => {
    const userClientId = state.user.selectedUserClientId;
    store.setState(
        R.evolve(
            {
                clients: {
                    [userClientId]: {
                        filters: {
                            isReturningFromOverride: R.always(true),
                        },
                    },
                },
            },
            state,
        ),
    );
};

export default setIsReturningFromOverride;
